import React, { Fragment, useEffect, useState } from 'react';

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { SSDComps } from '../../../../Brands/SSD/Start'; 
import { ComingSoon } from '../../../../Brands/ComingSoon'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import CompsAPI from '../Shared/DataCompAPI';
import Common from '../../../../Shared/Common';

export const Comps_PuckoResults = (props) => {
    return (
        <SSDComps>
            <Comps_PuckoResultsContent />
        </SSDComps>
    );
}   
export default Comps_PuckoResults;

export const Comps_PuckoResultsContent = (props) => {
    const [initalLoad, setInitialLoad] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [clubResults, setClubResults] = useState([]);
    const [filteredData, setFilteredData] = useState(clubResults);

    useEffect(() => {

        if (!initalLoad) {
            CompsAPI.getPuckoAwards({}, clubResultsCallback);
        }

        if (initalLoad) {
            const results = clubResults.filter(item => {
                if ((!searchTerm) || (searchTerm.length == 0))
                    return true;

                if (item.fishSpeciesShort) {
                    var result = (item.fishSpeciesShort.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (result)
                        return true;
                }

                if (item.diver) {
                    var result = (item.diver.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (result)
                        return true;
                }

                if (item.location) {
                    var result = (item.location.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (result)
                        return true;
                }
            }
            );
            setFilteredData(results);
        }

    }, [searchTerm]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    let clubResultsCallback = (data) => {
        setInitialLoad(true);

        setClubResults(data);
        setFilteredData(data);
    };

    let reset = () => { setSearchTerm(''); };

    return (
        <Block name="Records" isAlt={false}>

            <TextHeader
                text={"Pucko Awards over the Years"}
            />

            <Row>
                <Col lg="6">
                    <input
                        type="text"
                        placeholder="Search by Fish Species, Diver or location..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ padding: '8px', marginBottom: '16px', width: '300px' }}
                    />
                    {' '}
                    <Button color="danger" onClick={reset}>
                        <FontAwesomeIcon icon={faTrash} /> Reset
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Table striped hover borderless>
                        <thead>
                            <tr>
                                <th>
                                    Fish Species
                                </th>
                                <th>
                                    Diver
                                </th>
                                <th>
                                    Weight
                                </th>
                                <th>
                                    Date
                                </th>
                                <th>
                                    Location
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((entry, entryIndex) =>
                                <tr key={entryIndex}>
                                    <td>
                                        <span>{entry.fishSpeciesShort}</span>
                                    </td>
                                    <td>
                                        <span>{entry.diver}</span>
                                    </td>
                                    <td>
                                        <span>{entry.weight}</span>
                                    </td>
                                    <td>
                                        <span>{entry.catchdate}</span>
                                    </td>
                                    <td>
                                        <span>{entry.location}</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </Block>
    );
}
